/**
 * Block 12 calculator — `golaCount`: количество профилей Гола (штук).
 *
 * **Только Кухня** (per методике §В.1) — Шкаф/Балкон handleType ∈
 * {с ручками, от нажатия}, Гола не применяется.
 *
 * Длина профиля Гола = **4 м** (xlsx `Кухня!E45` константа).
 * Округление: `ceilToEven` (per OQ-5).
 *
 * Reference: `docs/methodology/calculator-formulas.md` §2.1 В.1 + §4.8.
 */

import { ceilToEven } from '../utils/ceilToEven';
import { assertPositiveDimension, type KitchenParams } from './types';

/**
 * Кухня прямая: `golaCount = ceilToEven(L / 4000)`.
 * Кухня угловая: `golaCount = ceilToEven((L + L2 - 600) / 4000)`.
 *
 * 4000 — длина 1 профиля Гола в мм (4 м).
 *
 * **Источник:** xlsx `Кухня!E45` + OQ-5.
 *
 * Reference: `docs/methodology/calculator-formulas.md` §2.1 В.1 + §4.8.
 *
 * @throws Error если `L = 0`, или угловая без `length2`, или `L+L2 ≤ 600`.
 * @example
 *   прямая L=5000 → ceilToEven(5000/4000) = ceilToEven(1.25) = 2
 *   угловая L=3000, L2=2000 → ceilToEven(4400/4000) = ceilToEven(1.1) = 2
 */
export function golaCountKitchen(params: KitchenParams): number {
  assertPositiveDimension(params.length, 'golaCountKitchen.length');

  let totalLmm: number;
  if (params.isAngular) {
    assertPositiveDimension(params.length2, 'golaCountKitchen.length2 (isAngular=true)');
    totalLmm = params.length + params.length2 - 600;
    if (totalLmm <= 0) {
      throw new Error(
        `golaCountKitchen: angular L+L2 must be > 600mm, got L=${params.length}, L2=${params.length2}`,
      );
    }
  } else {
    totalLmm = params.length;
  }

  return ceilToEven(totalLmm / 4000);
}
